import { Botao } from '../../../components/Botao'
import { Dialogo } from '../../../components/Dialogo'
import { AvisoDeErro } from '../../../components/Estados'
import type { AcaoDisponivel } from '../../../types/gmud'

interface Props {
  acao: AcaoDisponivel
  enviando: boolean
  erro: unknown
  aoConfirmar: () => void
  aoCancelar: () => void
}

/**
 * A confirmação das ações que desfazem trabalho já feito e que o servidor não pede justificativa.
 *
 * Quando o servidor exige motivo, quem confirma é o `DialogoDeMotivo`: escrever a justificativa
 * já é a pausa deliberada, e dois diálogos em sequência para a mesma ação viram dois cliques
 * automáticos. Este aqui cobre o outro caso — revogar uma aprovação ou aplicar rollback com um
 * clique só, ao lado de outro botão, numa reunião de comitê.
 *
 * O que ele mostra é o efeito, não a pergunta: "a solicitação passa para X" diz o que vai
 * acontecer; "tem certeza?" só transfere a dúvida para quem já não sabia.
 *
 * @param props a ação escolhida, o estado do envio e os desfechos
 * @returns o diálogo de confirmação
 */
export function DialogoDeConfirmacao({ acao, enviando, erro, aoConfirmar, aoCancelar }: Props) {
  return (
    <Dialogo
      titulo={acao.rotulo}
      descricao={`A solicitação passa para "${acao.statusDestinoRotulo}". A ação fica registrada na trilha com o seu nome e não pode ser apagada depois.`}
      aoFechar={aoCancelar}
      rodape={
        <>
          <Botao onClick={aoCancelar} disabled={enviando}>
            Cancelar
          </Botao>
          <Botao aparencia="perigo" onClick={aoConfirmar} disabled={enviando}>
            {enviando ? 'Enviando…' : `Confirmar: ${acao.rotulo}`}
          </Botao>
        </>
      }
    >
      <p className="text-sm text-slate-700">
        Se você abriu esta tela para outra coisa, cancele: esta ação desfaz o que já foi decidido ou executado, e
        voltar atrás exige percorrer o fluxo de novo, com nova decisão do comitê.
      </p>
      {Boolean(erro) && (
        <div className="mt-3">
          <AvisoDeErro erro={erro} titulo="A ação não foi concluída" />
        </div>
      )}
    </Dialogo>
  )
}
